import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import alertService from "../../../api/alertConfiguration.service";

export default {
  name: "view-alert-management",
  components: { pageheader },
  data() {
    return {
      input: {},
      alertDetails: null,
      isDetailsLoading: false,
      additionalDetails: [],
      alertNotifications: {
        applicationRecipients: [],
        emailRecipient: [],
        smsRecipient: [],
      },
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("alertmanagement", this.roles);
    const alertId = this.$route.params.id;
    this.getAlertsById(alertId);
    this.fetchAlertDetails(alertId);
  },
  methods: {
    async getAlertsById(alertId) {
      try {
        let response = await alertService.getAlertsDataById(alertId);

        if (response.data) {
          this.alertDetails = response.data;

          this.alertDetails.alertDateTime = response.data.alertDateTime
            ? response.data.alertDateTime.split("T")[0]
            : "";
        }
      } catch (err) {
        console.log("error", err);
      }
    },
    async fetchAlertDetails(alertId) {
      try {
        this.isDetailsLoading = true;
        let response = await alertService.getAlertsDataByIdDetails(alertId);

        if (response.data) {
          this.isDetailsLoading = false;

          this.alertNotifications = response.data;
        }
      } catch (err) {
        this.isDetailsLoading = false;
        console.log("error", err);
      }
    },
    getSeverityColors(severity) {
      const severityColors = {
        critical: { background: "#FEF0ED", text: "#D15A3A" },
        normal: { background: "#E4F0FB", text: "#5187E6" },
        low: { background: "#E1F6F8", text: "#5EBF74" },
      };
      const normalizedSeverity = severity?.toLowerCase();
      return (
        severityColors[normalizedSeverity] || {
          background: "#8891fd",
          text: "#0011de",
        }
      );
    },
    getBackgroundColorCode() {
      return this.getSeverityColors(this.alertDetails.severity).background;
    },
    getTextColorCode() {
      return this.getSeverityColors(this.alertDetails.severity).text;
    },
  },
};
